import React from 'react'
import { useGridApiRef, GridRowHeightParams } from '@mui/x-data-grid'
import { exportTableAsCSV } from 'tools/helper'
import strings from 'strings'
import { Box, Typography } from '@mui/material'
import { DataGridTable } from 'components'
import { getVehicleAssignmentsTableColumns } from './vehicleAssignmentsTableData'

const e = strings.CSV_EXPORT

interface IVehicleAssignmentsTableProps {
  data: any[]
  loading: boolean
  truncateDriverDisplay: (
    name: string,
    id: string,
    maxLength?: number
  ) => { name: string; id: string }
  getEstimatedRowHeight: ({
    model,
    densityFactor,
  }: GridRowHeightParams) => number | null
}

const VehicleAssignmentsTable: React.FC<IVehicleAssignmentsTableProps> = ({
  data,
  loading,
  truncateDriverDisplay,
  getEstimatedRowHeight,
}) => {
  const apiRef = useGridApiRef()

  const handleExport = () => {
    const csvString = apiRef.current.getDataAsCsv()
    exportTableAsCSV(csvString, e.VEHICLE_ASSIGNMENTS_CSV_EXPORT_NAME)
  }

  const tableMenuItems = [
    {
      label: e.DOWNLOAD_AS_CSV,
      key: 'export',
      action: () => {
        handleExport()
      },
    },
  ]

  return (
    <Box>
      <Typography variant="h2" color="text.primary" gutterBottom sx={{ mb: 2 }}>
        Vehicle Assignments
      </Typography>
      <DataGridTable
        apiRef={apiRef}
        showTitle={false}
        data={data}
        columns={getVehicleAssignmentsTableColumns(truncateDriverDisplay)}
        columnVisibilityModel={{
          rowId: false,
        }}
        checkboxSelection={false}
        totalCount={data.length}
        multiSearchFilter={false}
        getRowId={(row: any) => row.rowId}
        loading={loading}
        menuList={tableMenuItems}
        useDynamicRowHeight={true}
        getEstimatedRowHeight={getEstimatedRowHeight}
      />
    </Box>
  )
}

export default VehicleAssignmentsTable
